import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Typography, TextField } from "@mhome/ui";

const DateInput = ({ valueSpec, onChange, zIndex = 100 }) => {
  const [value, setValue] = useState(null);
  const isReadOnly = valueSpec.readOnly;

  useEffect(() => {
    setValue(dayjs(valueSpec.value));
    return () => {};
  }, [valueSpec]);

  const handleValueChange = (data) => {
    if (isReadOnly) return;
    const y = data.$y;
    const m = data.$M + 1;
    const d = data.$D;
    const date = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d}`;
    setValue(data);
    onChange(date);
  };

  return (
    <div
      className="flex flex-col w-full h-full overflow-hidden items-stretch justify-center"
      style={{ zIndex }}
    >
      <div className="flex-1 flex" style={{ zIndex }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <MobileDatePicker
            value={value}
            onAccept={handleValueChange}
            readOnly={isReadOnly}
            disabled={isReadOnly}
            slotProps={{
              textField: {
                size: "small",
                fullWidth: true,
                sx: {
                  flex: 1,
                  zIndex,
                  "& .MuiInputBase-root": {
                    height: "100%",
                  },
                  "& .MuiInputBase-input": {
                    height: "100%",
                    padding: "0 8px",
                    display: "flex",
                    alignItems: "center",
                    cursor: isReadOnly ? "default" : "pointer",
                  },
                },
              },
              dialog: {
                sx: {
                  zIndex,
                  "& .MuiDialog-paper": {
                    zIndex,
                  },
                },
              },
              mobilePaper: {
                sx: {
                  zIndex,
                },
              },
              popper: {
                sx: {
                  zIndex,
                },
              },
            }}
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              zIndex,
              "& .MuiTextField-root": {
                flex: 1,
                display: "flex",
              },
              "& .MuiPickersLayout-root": {
                minHeight: "auto",
                zIndex,
              },
            }}
          />
        </LocalizationProvider>
      </div>
    </div>
  );
};

export default DateInput;
